// import React from "react";

// const Star = () => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="15"
//       height="14"
//       viewBox="0 0 15 14"
//       fill="none"
//     >
//       <path
//         d="M11.6677 13.9964C11.5475 13.9969 11.4289 13.9691 11.3219 13.9154L7.48873 11.9489L3.65553 13.9154C3.53106 13.9795 3.39073 14.0081 3.25048 13.998C3.11023 13.9879 2.97569 13.9394 2.86216 13.8581C2.74863 13.7767 2.66066 13.6658 2.60826 13.538C2.55585 13.4101 2.54111 13.2704 2.56571 13.1347L3.31731 8.98824L0.220694 6.04227C0.124081 5.94779 0.0555447 5.82932 0.0224411 5.69957C-0.0106625 5.56982 -0.00708408 5.43368 0.0327924 5.30577C0.0763554 5.17488 0.156489 5.05857 0.264099 4.97005C0.37171 4.88153 0.502488 4.82433 0.641594 4.80496L4.92575 4.19367L6.81228 0.415463C6.87383 0.290943 6.96992 0.185929 7.08956 0.11245C7.20919 0.0389717 7.34753 0 7.48873 0C7.62992 0 7.76826 0.0389717 7.8879 0.11245C8.00753 0.185929 8.10363 0.290943 8.16517 0.415463L10.0743 4.1863L14.3584 4.79759C14.4975 4.81697 14.6283 4.87416 14.7359 4.96269C14.8435 5.05121 14.9236 5.16751 14.9672 5.29841C15.0071 5.42632 15.0107 5.56245 14.9776 5.69221C14.9445 5.82196 14.8759 5.94043 14.7793 6.0349L11.6827 8.98087L12.4343 13.1273C12.4611 13.2654 12.4471 13.4081 12.3938 13.5386C12.3405 13.6691 12.2503 13.782 12.1337 13.8638C11.9976 13.9573 11.8337 14.0039 11.6677 13.9964Z"
//         fill="#231F20"
//       />
//     </svg>
//   );
// };

// export default Star;

import React from "react";

const Star = ({ color = "#111111" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M11.6677 13.9964C11.5475 13.9969 11.4289 13.9691 11.3219 13.9154L7.48873 11.9489L3.65553 13.9154C3.53106 13.9795 3.39073 14.0081 3.25048 13.998C3.11023 13.9879 2.97569 13.9394 2.86216 13.8581C2.74863 13.7767 2.66066 13.6658 2.60826 13.538C2.55585 13.4101 2.54111 13.2704 2.56571 13.1347L3.31731 8.98824L0.220694 6.04227C0.124081 5.94779 0.0555447 5.82932 0.0224411 5.69957C-0.0106625 5.56982 -0.00708408 5.43368 0.0327924 5.30577C0.0763554 5.17488 0.156489 5.05857 0.264099 4.97005C0.37171 4.88153 0.502488 4.82433 0.641594 4.80496L4.92575 4.19367L6.81228 0.415463C6.87383 0.290943 6.96992 0.185929 7.08956 0.11245C7.20919 0.0389717 7.34753 0 7.48873 0C7.62992 0 7.76826 0.0389717 7.8879 0.11245C8.00753 0.185929 8.10363 0.290943 8.16517 0.415463L10.0743 4.1863L14.3584 4.79759C14.4975 4.81697 14.6283 4.87416 14.7359 4.96269C14.8435 5.05121 14.9236 5.16751 14.9672 5.29841C15.0071 5.42632 15.0107 5.56245 14.9776 5.69221C14.9445 5.82196 14.8759 5.94043 14.7793 6.0349L11.6827 8.98087L12.4343 13.1273C12.4611 13.2654 12.4471 13.4081 12.3938 13.5386C12.3405 13.6691 12.2503 13.782 12.1337 13.8638C11.9976 13.9573 11.8337 14.0039 11.6677 13.9964Z"
        fill={color} // Dynamically set color
      />
    </svg>
  );
};

export default Star;
